<template lang="pug">
base-layout
  template(v-slot:nuxt)
    .dashboard
      k-container.py-0.brand-dark-blue-70.hidden-md-and-up
        v-tabs(
          dark
          hide-slider
          show-arrows
        ).dashboard__tabs--mobile.dashboard__tabs
          v-tab(
            v-for="item in dashboardLinks"
            :key="item.name"
            link
            :to="item.link"
            :ripple="false"
            @click="updateActiveTab"
          )
            v-badge(
              right
              top
              :value="item.alerts > 0 ? item.alerts : false"
            )
              template(v-slot:badge) {{ item.alerts }}
              span {{ item.name }}
      k-container
        v-row
          v-col(cols="3").hidden-sm-and-down
            k-card(color="brand-dark-blue-60" flat)
              .white--text.small-caps.px-8.py-5 My Dashboard
              v-navigation-drawer(
                permanent
                color="brand-dark-blue-70"
                dark
              )
                v-list.py-0
                  template(
                    v-for="item in dashboardLinks"
                  )
                    v-list-item(
                      :key="item.name"
                      link
                      :inactive="item.link === activeDashboardTab.link"
                      :to="item.link"
                      :ripple="false"
                    )
                      v-list-item-icon
                        k-icon(:color="item.link === activeDashboardTab.link ? 'brand-pink' : 'brand-warm-grey'" :size="item.iconSize") {{ item.icon }}
                      v-list-item-content
                        v-list-item-title
                          .d-flex.align-items-center
                            span(:class="item.link === activeDashboardTab.link ? 'font-weight-bold' : ''") {{ item.name }}
                            k-chip(
                              v-if="item.alerts"
                              x-small
                              color="white"
                              text-color="brand-dark-blue-70"
                              right
                              top
                            ).ml-4 {{ item.alerts }}
                        template(v-if="item.link === activeDashboardTab.link")
                          template(v-for="sub in item.sub")
                            nuxt-link(
                              :to="sub.link"
                              :class="sub.link === activeSub ? 'underline' : 'unstyled--link'"
                            ).brand-grey-40--text.paragraph--book.d-block.dashboard__tabs--sub {{ sub.name }}
          v-col(md="9" cols="12")
            .ml-lg-10.ml-md-5
              .title--semi-large(v-if="activeDashboardTab.name !== 'Overview' && !hideSub").font-family--secondary.font-weight-bold.hidden-sm-and-down.mb-7 {{ activeDashboardTab.name }}
              v-tabs(v-if="activeDashboardTab.sub && !hideSub" ref="tabs" v-model="activeSub").dashboard__tabs.dashboard__tabs--sub.pb-10
                template(v-for="tab in activeDashboardTab.sub")
                  v-tab(
                    :ripple="false"
                    :link="!tab.link"
                    :to="tab.link"
                    exact
                    :active-class="'font-weight-bold brand-dark-blue--text'"
                    :key="tab.name"
                  )
                    v-badge(
                      :key="tab.name"
                      right
                      top
                      :value="tab.alerts > 0 ? tab.alerts : false"
                    )
                      template(v-slot:badge) {{ tab.alerts }}
                      span {{ tab.name }}
              nuxt
</template>


<script>
import BaseLayout from '@/layouts/base'
import { UsesAuthenticatedUser, UsesDashboardLinks } from '@/mixins'
import { find, findIndex } from 'lodash'
import { sync } from 'vuex-pathify'

export default {
  components: { BaseLayout },
  mixins: [
    UsesAuthenticatedUser,
    UsesDashboardLinks
  ],
  data () {
    return {
      activeSub: '',
    }
  },
  computed: {
    ...sync({
      activeDashboardTabIndex: 'myKintell/activeDashboardTabIndex'
    }),
    // Hacky way to hide the sub tabs when on a booking page
    hideSub () {
      const regex = /\/my-kintell\/bookings\/[^-]+(-[^-]+)+$/g // regex matches url for booking page
      return this.$route.path.match(regex)
    },
    activeDashboardTab () {
      return this.dashboardLinks[this.activeDashboardTabIndex]
    },
  },
  watch: {
    $route: {
      handler () {
        this.updateActiveTab()
      },
      immediate: true
    }
  },
  mounted () {
    document.fonts && document.fonts.ready.then(() => this.$nextTick()).then(() => {
      if (this.$refs.tabs) {
        this.$refs.tabs.callSlider()
      }
    })
  },
  methods: {
    updateActiveTab () {
      const path = this.$route.path
      // if it changes to a dashboard page
      if (path.includes('my-kintell')) {
        this.activeDashboardTabIndex = findIndex(this.dashboardLinks, e => path.includes(e.link))
        // update subtitle
        if (this.activeDashboardTab.sub) {
          const sub = find(this.activeDashboardTab.sub, e => path.endsWith(e.link))
          if (sub) {
            this.activeSub = sub.link
          }
        }
      } else {
        this.activeDashboardTabIndex = 0
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.v-navigation-drawer {
  width: 100% !important;
}

::v-deep {
  .theme--dark.v-list {
    background-color: var(--v-brand-dark-blue-70-base) !important;
  }

  .v-list-item {
    border-top: 1px solid rgba(255, 255, 255, .1);

    &__title {
      @extend %paragraph;
    }
  }

  .v-list-item__content {
    padding: 19px 0 !important;
  }

  .v-list-item {
    padding: 0 25px !important;

    @include md-and-down {
      padding: 0 15px !important;
    }
  }

  .v-list-item__icon {
    margin: 0 !important;
    padding: 22px 0 !important;
    width: 50px;
    @include md-and-down {
      width: 35px;
    }
  }
}

::v-deep {
  .v-list-item__content > *:not(:last-child) {
    margin-bottom: 12px;
  }
}

.dashboard__tabs {
  &--mobile {
    ::v-deep {
      .v-tabs-bar {
        background-color: var(--v-brand-dark-blue-70-base) !important;
        height: 63px !important;
      }

      .v-tab {
        color: white !important;
        font-size: 18px !important;
        font-weight: normal !important;
        height: 63px !important;

        &--active {
          font-weight: bold !important;
        }
      }
    }
  }

  &--sub {
    ::v-deep {
      .v-tabs-bar {
        background-color: transparent !important;
        height: 41px;
      }
    }
  }

  ::v-deep {
    .v-slide-group__content {
      @include sm-and-down {
        justify-content: center;
      }
    }

    .v-slide-group__prev--disabled {
      display: none !important;
    }

    .v-tab {
      @extend %paragraph--semi-medium;
      color: var(--v-secondary-base);
      height: 41px;
      letter-spacing: 0 !important;
      margin-right: 30px !important;
      min-width: 45px;
      padding: 0 !important;
      text-align: center;
      text-transform: none;
      transition: .2s color;

      &::before {
        display: none !important;
      }

      &:not(.v-tab--active) {
        &:hover {
          color: var(--v-primary-base) !important;
        }
      }
    }

    .v-tab--active {
      font-weight: bold;
    }

    .v-tabs-bar {
      background-color: transparent !important;
      height: 41px;
    }
  }
}
</style>
